// removed by extract-text-webpack-plugin
module.exports = {"PopUp":"src-componentsEn-ToolTip----ToolTip-module---PopUp---2Xec2","Tip":"src-componentsEn-ToolTip----ToolTip-module---Tip---2B3we"};


//////////////////
// WEBPACK FOOTER
// ./src/componentsEn/ToolTip/ToolTip.module.css
// module id = 435
// module chunks = 81697171470250